<template>
  <div class="download-component tva-row">
    <div class="download tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-offset-5 tva-col-md-7">
      <div class="download-icon">
        <svgicon icon="download-arrow" width="16" height="17"></svgicon>
      </div>

      <a :href="content.url" target="_blank">{{content.text}}</a>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content"]
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
.download-component {
  padding-top: 50px;
  .download {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 30px;
    width: fit-content;
    padding-right: 20px;
    border-right: solid 1px $eni-yellow;
    border-top: solid 1px $eni-yellow;
    border-bottom: solid 1px $eni-yellow;
    cursor: pointer;
    transition: all 0.5s ease;
    &:hover {
      .download-icon {
        background: $eni-yellow;
        transition: all 0.5s ease;
      }
    }
    .download-icon {
      height: 40px;
      width: 40px;
      border: solid 1px $eni-yellow;

      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    a {
      font-family: "Avenir Next";
      text-transform: uppercase;
      font-size: 14px;
      padding: 3px 15px 0 10px;
      font-weight: 600;
      letter-spacing: 0.5px;
      color: black;
    }
  }
}
@media (max-width: 720px) {
  .download-component {
    width: 100vw;
    padding: 0 20px;
    .download {
      flex-direction: column;
      align-items: center;
      border-left: solid 1px $eni-yellow;
      margin: 0 !important;
      a {
        text-align: center;
        padding: 13px 15px 10px;
      }
      .download-icon {
        display: none;
      }
      p {
        font-size: 12px;
        text-align: center;
      }
    }
  }
}
</style>
